import {Params} from '@angular/router';

// import {PropsMapping} from '@shared/interfaces';
import {Model} from './model';
import {SubscriptionModel} from './subscription.model';
import {TeamModel} from './team.model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'drawingId',
  tournamentCategoryId: 'tournamentCategoryId',
  eventId: 'eventId',
  subscriptionId: 'subscriptionId',
  teamId: 'teamId',
  stage: 'stage',
  group: 'group',
  sort: 'sort',
  isSeed: 'isSeed',
  bye: 'bye',

  // @TODO: deprecated
  // player: 'player',

  subscription: 'subscription',
  team: 'team',
};

export class DrawingModel extends Model {
  tournamentCategoryId!: number;
  eventId!: number;
  subscriptionId!: number;
  teamId!: number;
  stage!: string;
  group!: number;
  sort!: number;
  isSeed!: boolean;
  bye!: boolean;

  subscription?: SubscriptionModel;
  team?: TeamModel;

  get avatarImg(): string {
    if (!this.team) {
      // Imagen por defecto
      return 'player.png';
    }

    if (this.team.teamAvatar) {
      return String((this.team.teamAvatar % 30) + 1) + '.png';
    }

    if (this.team.playerAvatar) {
      return String((this.team.playerAvatar % 30) + 1) + '.png';
    }

    if (this.team?.name) {
      // Imagen por defecto del equipo
      return 'team.png';
    }

    // Imagen por defecto del jugador
    // @TODO: validar el genero del jugador para mostrar un avatar femenino
    // o masculino
    return 'player.png';
  }

  static getInstance(data: Params): DrawingModel {
    const model = new DrawingModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      if (prop === 'subscription') {
        (model as Params)[prop] = SubscriptionModel.getInstance(data[propsMapping[prop]]);
      } else if (prop === 'team') {
        (model as Params)[prop] = TeamModel.getInstance(data[propsMapping[prop]]);
      } else {
        (model as Params)[prop] = data[propsMapping[prop]];
      }
    }

    return model;
  }

  // static searchByEventId(
  //   apiService: ApiService,
  //   eventId: number,
  //   urlParams?: HttpParams
  // ): Observable<ListState<DrawingModel>> {
  //   return apiService
  //     .get(`events/${eventId}/drawings`, urlParams)
  //     .pipe(
  //       map((data: Params): ListState<DrawingModel> => {
  //         const list: DrawingModel[] = data['data'].map((item: Params): DrawingModel =>
  //           DrawingModel.getInstance(item)
  //         );
  //
  //         // const paginator: Paginator = {
  //         //   total: data.total,
  //         //   perPage: data.perPage,
  //         //   currentPage: data.currentPage,
  //         //   lastPage: data.lastPage,
  //         //   // from: data.from,
  //         //   // to: data.to
  //         // };
  //
  //         // return {list, paginator};
  //         return {list};
  //       })
  //     );
  // }

  // static searchByTournamentId(
  //   apiService: ApiService,
  //   tournamentId: number,
  //   urlParams?: HttpParams
  // ): Observable<ListState<DrawingModel>> {
  //   return apiService
  //     .get(`tournaments/${tournamentId}/drawings`, urlParams)
  //     .pipe(
  //       map((data: Params): ListState<DrawingModel> => {
  //         const list: DrawingModel[] = data['data'].map((item: Params): DrawingModel =>
  //           DrawingModel.getInstance(item)
  //         );
  //
  //         // const paginator: Paginator = {
  //         //   total: data.total,
  //         //   perPage: data.perPage,
  //         //   currentPage: data.currentPage,
  //         //   lastPage: data.lastPage,
  //         //   // from: data.from,
  //         //   // to: data.to
  //         // };
  //
  //         // return {list, paginator};
  //         return {list};
  //       })
  //     );
  // }
}
